import { Component, OnInit, OnDestroy, ViewChild, ElementRef, DoCheck, AfterViewInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { SidenavService } from 'src/app/services/sidenav.service';
import { AppStateProvider } from 'src/app/services/app-state.provider';
import { Subscription } from 'rxjs';
import { NgbModal, ModalDismissReasons, NgbCalendar, NgbDate, NgbDateAdapter } from '@ng-bootstrap/ng-bootstrap';
import { Dimensions, ImageCroppedEvent, ImageTransform } from 'ngx-image-cropper';
import { DomSanitizer } from '@angular/platform-browser';
import { Foodcourt } from 'src/app/model/foodcourt.model';
import { AddfoodvendorService } from 'src/app/services/addfoodvendor.service';
import { FoodcourtService } from 'src/app/services/foodcourt.service';
import { DateService } from 'src/app/services/date.service';
import { CommonService } from 'src/app/services/common.service';

@Component({
  standalone: false,
  selector: 'app-update-vendor',
  templateUrl: './update-vendor.component.html',
  styleUrls: ['./update-vendor.component.scss']
})
export class UpdateVendorComponent implements OnInit {

  @ViewChild('uploadImages', { static: false }) uploadImages: ElementRef;

  public foodcourt = new Foodcourt();
  private subscriptions = new Subscription();
  public accordianIcon = '../../../assets/images/icons/chevron_up.svg';

  prakList: any = [];
  finalSubmissionArray = [];
  afterConvertFile: any = [];
  images = [];
  activeIds: string[] = ['form_row_01', 'form_row_02', 'form_row_03'];
  currentProcessingImg: any = 0;
  imgId: any = 0;
  finalImageList: any = [];
  photoData: any = {};
  uploadData: any;
  selectedPark = localStorage.getItem('parkId');
  parkDetails;
  displayPark = '';
  daysOfOperation = [];
  vendorId: any;
  vendorDetails: any;
  ismarkAsClosed: boolean = false;
  checkedOnlyUsersList: any;
  imageObject = [];
  foodCourtList: any = [];

  amorpm: boolean = false;
  amorpm1: boolean = false;
  startTimePlaceholder: string = '';
  endTimePlaceholder: string = '';
  meridian: boolean = true;
  startTime = { hour: 6, minute: 0 };
  endTime = { hour: 6, minute: 0 };
  time: any;
  editedStartTime: any;
  editedToTime: any;

  myForm!: FormGroup;
  imageTobeUpload: any;
  parkId: any;

  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private sideNavService: SidenavService,
    private appStateSrv: AppStateProvider,
    private modalService: NgbModal,
    private sanitizer: DomSanitizer,
    private acroute: ActivatedRoute,
    private dateAdapter: NgbDateAdapter<string>,
    private dateSrv: DateService,
    private addfoodvendorService: AddfoodvendorService,
    private foodcourtService: FoodcourtService,
    private commonService: CommonService,
    private route: ActivatedRoute,
  ) {
    this.myForm = this.formBuilder.group({
      FoodCourtVendorName: ['', [Validators.required, Validators.maxLength(100)]],
      FromDaysOperation: ['', [Validators.required]],
      ToDaysOperation: ['', [Validators.required]],
      FromTimeOperation: ['', [Validators.required]],
      FromTimeOperation1: [''],
      ToTimeOperation: ['', [Validators.required]],
      ToTimeOperation1: [''],
      ParkId: [''],
      file: [''],
      VendorPhotos: [''],
      ModifiedBy: '',
      //IsMarkClosed: false,
      isActive: true,
      FoodCourtVendorPhotoId: '',
      FoodCourtId: ['', [Validators.required]],
    });

    localStorage.setItem('expandNavFoodCourt', 'true');
    const routeLink = this.sideNavService.routingChunks({
      name: 'Food Court Management',
      subNav: '1',
      subNavLink: '',
    });
    this.appStateSrv.setSideNavState(routeLink);
  }

  ngOnInit(): void {
    localStorage.removeItem('expandNav');
    localStorage.removeItem('expandNavLand');
    localStorage.removeItem('expandNavCreateview');
    this.selectedPark = localStorage.getItem('parkId');

    this.foodcourt.ParkId = '';
    this.foodcourt.FromDaysOperation = '';
    this.foodcourt.ToDaysOperation = '';

    this.subscriptions = this.commonService.parkDropDownDetailsArray.subscribe(
      (res) => {
        this.parkDetails = res;
        this.parkDetails = this.parkDetails.length > 0 ? this.parkDetails : JSON.parse(localStorage.getItem('parkDropDownDetails'));
        this.selectedPark = localStorage.getItem('parkId');
        if (this.parkDetails != null && this.selectedPark == null) {
          this.displayPark = this.parkDetails[0].parkName + ', ' + this.parkDetails[0].cityName;
        } else if (this.parkDetails != null && this.selectedPark) {
          this.parkDetails.forEach((element) => {
            if (element.parkId === this.selectedPark) {
              this.displayPark = element.parkName + ', ' + element.cityName;
            }
          });
        }
      }
    );

    this.daysOfOperation.push(
      {
        id: "1",
        name: "Monday"
      },
      {
        id: "2",
        name: "Tuesday"
      },
      {
        id: "3",
        name: "Wednesday"
      },
      {
        id: "4",
        name: "Thursday"
      },
      {
        id: "5",
        name: "Friday"
      },
      {
        id: "6",
        name: "Saturday"
      },
      {
        id: "0",
        name: "Sunday"
      }
    );

    this.route.params.subscribe((params) => {
      this.vendorId = params['id'];
    });

    this.getFoodCourtList();
    this.getVendorDetails();
  }

  getVendorDetails() {
    this.foodcourtService.getVendorDetails(this.vendorId).subscribe((res) => {
      if (res?.isValid === true) {
        this.vendorDetails = res;
        this.ismarkAsClosed = this.vendorDetails?.data.isMarkClosed;

        this.foodcourt.FoodCourtVendorName = this.vendorDetails.data?.foodCourtVendorName;
        this.foodcourt.FromDaysOperation = this.vendorDetails.data?.fromDaysOperation;
        this.foodcourt.ToDaysOperation = this.vendorDetails.data?.toDaysOperation;
        this.foodcourt.FromTimeOperation = this.vendorDetails.data?.fromTimeOperation;
        this.foodcourt.ToTimeOperation = this.vendorDetails.data?.toTimeOperation;
        this.foodcourt.FoodCourtId = this.vendorDetails.data?.foodCourtId;

        this.parkId = this.vendorDetails.data?.parkId;

        this.myForm.controls.FromTimeOperation.setValue(this.vendorDetails.data?.fromTimeOperation);
        this.myForm.controls.ToTimeOperation.setValue(this.vendorDetails.data?.toTimeOperation);

        this.editedStartTime = this.vendorDetails.data?.fromTimeOperation;
        this.editedToTime = this.vendorDetails.data?.toTimeOperation;

        this.convertStringFromTime(this.vendorDetails.data?.fromTimeOperation);
        this.convertStringToTime(this.vendorDetails.data?.toTimeOperation);

        for (let i = 0; i <= this.vendorDetails.data?.foodCourtVendorPhotos.length - 1; i++) {
          this.imageObject.push({
            image: this.vendorDetails.data?.foodCourtVendorPhotos[i].foodCourtVendorPhotoPath,
            thumbImage: this.vendorDetails.data?.foodCourtVendorPhotos[i].foodCourtVendorPhotoPath,
          });
        }

        for (let i = 0; i <= this.vendorDetails.data?.foodCourtVendorPhotos.length - 1; i++) {
          fetch(this.vendorDetails.data?.foodCourtVendorPhotos[i].foodCourtVendorPhotoPath)
            .then((response) => response.blob())
            .then((blob) => {
              var reader = new FileReader();
              // const url = URL.createObjectURL(blob);
              reader.readAsDataURL(blob);
              reader.onload = (innerEvent: any) => {
                this.afterConvertFile.push(
                  this.dataURLtoFile(
                    innerEvent.target.result,
                    this.vendorDetails.data?.foodCourtVendorPhotos[i].foodCourtVendorPhotoPath.split('?').at(0).split('/').at(4)
                  )
                );
              };
            });
        }

        console.log(this.afterConvertFile);

        this.checkedOnlyUsersList = [];
        this.checkedOnlyUsersList.push(this.vendorDetails.data);
      }
    });
  }

  ngOnDestroy() {
    localStorage.removeItem('expandNavCreateview');
    this.subscriptions.unsubscribe();
  }

  getParkDetails() {
    this.foodcourtService.getParkByCLAId().subscribe((res) => {
      if (res.isValid) {
        this.prakList = res.list;
      }
    });
  }

  getFoodCourtList() {
    this.foodcourtService.mainFoodCourtList().subscribe((res) => {
      if (res.isValid) {
        this.foodCourtList = res.list;
      }
    });
  }

  convertFormat(y, m, d) {
    return y + '-' + m + '-' + d;
  }

  onFileChange(event: any, file?: any) {
    if (event.target.files && event.target.files[0]) {
      const fileItem = event.target.files[0];
      console.log(fileItem);

      var filesAmount = event.target.files.length;

      for (let i = 0; i < filesAmount; i++) {
        var reader = new FileReader();
        reader.readAsDataURL(event.target.files[i]);

        reader.onload = (innerEvent: any) => {
          // this.imgId = this.imgId + 1;
          this.images.push({
            // imgId: this.imgId,
            imgBase64: innerEvent.target.result,
            imgFile: event.target.files[i],
            cropped: false,
          });

          this.myForm.patchValue({
            VendorPhotos: this.images,
          });
        };
      }
      console.log(this.images);
    }
  }

  dataURLtoFile(dataurl: string, filename: any) {
    var arr = dataurl.split(','),
      mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[arr.length - 1]),
      n = bstr.length,
      u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], filename.split('?').at(0), { type: mime });
  }

  goToListPage() {
    this.router.navigate(['/vendor-details/'+this.vendorId]);
  }

  removeImage(i: any) {
    console.log(i);
    this.images.splice(i, 1);
  }

  removeImageOld(i: any) {
    this.afterConvertFile.length = 0;
    this.vendorDetails.data?.foodCourtVendorPhotos.splice(i, 1);

    for (let i = 0; i <= this.vendorDetails.data?.foodCourtVendorPhotos.length - 1; i++) {
      // this.convertImageToBase64(this.vendorDetails.data?.foodCourtVendorPhotos[i].foodCourtVendorPhotoPath, function (dataURL: any) {
      // });

      console.log(this.vendorDetails.data?.foodCourtVendorPhotos[i].foodCourtVendorPhotoPath);

      fetch(this.vendorDetails.data?.foodCourtVendorPhotos[i].foodCourtVendorPhotoPath)
        .then((response) => response.blob())
        .then((blob) => {
          var reader = new FileReader();
          // const url = URL.createObjectURL(blob);
          reader.readAsDataURL(blob);
          reader.onload = (innerEvent: any) => {
            this.afterConvertFile.push(
              this.dataURLtoFile(
                innerEvent.target.result,
                this.vendorDetails.data?.foodCourtVendorPhotos[i].foodCourtVendorPhotoPath.split('?').at(0).split('/').at(4),
              )
            );
          };
        });
    }

    console.log(this.afterConvertFile);

    if (this.vendorDetails.data?.foodCourtVendorPhotos.length - 1 == -1) {
      this.afterConvertFile.length = 0;
    }
  }

  //Time
  onTimeChange(e) {
    console.log(e, this.amorpm);
    if (e.hour >= 0 && e.hour <= 11) this.amorpm = false;
    else this.amorpm = true;
    this.startTimePlaceholder =
      ('0' + (e.hour > 12 ? e.hour - 12 : e.hour)).slice(-2) +
      ':' +
      ('0' + e.minute).slice(-2) +
      ' ' +
      (this.amorpm ? 'PM' : 'AM');
    console.log('time', this.startTimePlaceholder);
    this.myForm.controls.FromTimeOperation.setValue(this.startTimePlaceholder);
    // this.myForm.controls.FromTimeOperation.setValue(this.editedStartTime);
  }

  onTimeChangeTo(e) {
    console.log(e, this.amorpm);
    if (e.hour >= 0 && e.hour <= 11) this.amorpm = false;
    else this.amorpm = true;
    this.endTimePlaceholder =
      ('0' + (e.hour > 12 ? e.hour - 12 : e.hour)).slice(-2) +
      ':' +
      ('0' + e.minute).slice(-2) +
      ' ' +
      (this.amorpm ? 'PM' : 'AM');
    console.log('time', this.endTimePlaceholder);
    this.myForm.controls.ToTimeOperation.setValue(this.endTimePlaceholder);
    // this.myForm.controls.ToTimeOperation.setValue(this.editedToTime);
  }

  toggleAmPmSelection(value: boolean) {
    this.amorpm = value;
    // this.onTimeChange(this.normalizeTime);
  }

  toggleMeridian() {
    this.meridian = !this.meridian;
  }

  convertStringFromTime(time12h) {
    const [time, modifier] = time12h.split(' ');

    let [hours, minutes] = time.split(':');

    if (hours === '12') {
      hours = '00';
    }

    if (modifier === 'PM') {
      hours = parseInt(hours, 10) + 12;
    }

    this.startTime = { hour: parseInt(hours), minute: parseInt(minutes) };

    console.log(hours, minutes)
  }

  convertStringToTime(time12h) {
    const [time, modifier] = time12h.split(' ');

    let [hours, minutes] = time.split(':');

    if (hours === '12') {
      hours = '00';
    }

    if (modifier === 'PM') {
      hours = parseInt(hours, 10) + 12;
    }

    this.endTime = { hour: parseInt(hours), minute: parseInt(minutes) };

    console.log(hours, minutes)
  }

  enterName(field) {
    if (field == 'time') {
      this.time = !this.time;
    }
  }

  openPopover(popover) {
    if (popover.isOpen()) {
      popover.close();
    } else {
      popover.open();
    }
  }

  openPopoverTo(popover) {
    if (popover.isOpen()) {
      popover.close();
    } else {
      popover.open();
    }
  }

  onClickedOutside(e: Event) {
    console.log('Clicked outside:', e);
  }

  onClickedOutsideTo(e: Event) {
    console.log('Clicked outside:', e);
  }

  onSubmit(): void {
    console.log(this.myForm.value);
    this.uploadData = new FormData();

    this.myForm.patchValue({
      ModifiedBy: localStorage.getItem('claAdminId'),
      isActive: true,
    } as any);

    for (let i = 0; i <= this.images.length - 1; i++) {
      this.afterConvertFile.push(
        this.dataURLtoFile(
          this.images[i].imgBase64,
          this.images[i].imgFile.name
        )
      );
    }

    let imgFileProperties = this.afterConvertFile.map(
      (img: any, filename: any) => {
        let properties = {
          photoData: img,
          foodCourtVendorPhotoName: img.name,
          FoodCourtVendorPhotoId: ''
        };
        return properties;
      }
    );

    const uploadData = new FormData();

    for (let i = 0; i <= imgFileProperties.length - 1; i++) {
      uploadData.append('VendorPhotos[' + i + '].photoData', imgFileProperties[i].photoData);
      uploadData.append('VendorPhotos[' + i + '].foodCourtVendorPhotoName', imgFileProperties[i].foodCourtVendorPhotoName.split('?').at(0));
      uploadData.append('VendorPhotos[' + i + '].FoodCourtVendorPhotoId', imgFileProperties[i].FoodCourtVendorPhotoId);
      // uploadData.append('VendorPhotos[' + i + '].FoodCourtVendorPhotoId', '0');
    }

    uploadData.append('FoodCourtVendorId', this.vendorId);
    uploadData.append('FoodCourtVendorName', this.myForm.value.FoodCourtVendorName);
    uploadData.append('IsMarkClosed', this.ismarkAsClosed.toString());
    uploadData.append('FromDaysOperation', this.myForm.value.FromDaysOperation);
    uploadData.append('ToDaysOperation', this.myForm.value.ToDaysOperation);
    uploadData.append('FromTimeOperation', this.myForm.value.FromTimeOperation);
    uploadData.append('ToTimeOperation', this.myForm.value.ToTimeOperation);
    // uploadData.append('ParkId', this.parkId);
    uploadData.append('ModifiedBy', localStorage.getItem('claAdminId'));
    uploadData.append('IsActive', 'true');
    uploadData.append('FoodCourtId', this.myForm.value.FoodCourtId);

    this.myForm.patchValue({
      VendorPhotos: imgFileProperties,
    });


    if (this.myForm.valid) {
      console.log("Yes");
      this.addfoodvendorService
        .updateFoodCourtVendor(uploadData)
        .subscribe((res) => {
          this.router.navigate(['/vendor-details/'+this.vendorId]);
        });
    } else {
      console.log("No");
      this.myForm.markAllAsTouched();
    }
  }

}
